import { Flex } from "antd";
import styled from "styled-components";

export const NotFoundDiv = styled(Flex)`
    margin: 10px;
    width: 100%;
`;